/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { Tab } from './Tab/Tab';

export const Tabs = props => (
  <div className="tabs">
    {props.data.map((tab, i) => (
      <Tab
        key={`tab-${i}`}
        category={tab.category}
        image={tab.image}
        tabIndex={i}
        {...props}
      />
    ))}
  </div>
);

Tabs.propTypes = {
  data: PropTypes.shape([]).isRequired
};
